module.exports = __webpack_public_path__ + "26d42c9.woff";